import CreateShopOrderItemRequestModelBase from '../_generated/modelBases/create-shop-order-item-request-model-base';

export default class CreateShopOrderItemRequestModel extends CreateShopOrderItemRequestModelBase {
  // For instructions on how to use Models visit:
  // https://glittrsoftware.visualstudio.com/glittr.core/_wiki/wikis/glittr.core.wiki/429/ServiceModels-DTOs
}
